import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const numericAndLettersOnlyValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const value = control.value;

  // Allow empty values (so required validator can handle emptiness)
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const regex = /^[A-Za-z0-9]+$/;

  const valid = regex.test(value);
  return valid ? null : { numericAndLettersOnly: true };
};
